export default {
    documentTitle: "Hungry Jack's Ordering",
    documentDescription: "Order Hungry Jacks online description placeholder.",
    asapDeliveryEstimate: "Estimated delivery time: ",
    cartDisclaimer:
        "Prices may vary at time of purchase. The average adult daily energy intake is 8700kJ. kJs & Allergens do not update on removal of standard inclusions.",
    minimumOrderAmount: "Minimum order not reached"
};
